<template>
  <div class="bind-page">
    <div class="bind-header">
      <p>欢迎绑定用水账户</p>
      <span class="toggle-code" @click="toSearchNO">查询户号</span>
      <!-- <span>您还未绑定任何用水账户，请先绑定！</span> -->
    </div>
    <!-- <div class="business">
          <div class="toggletab" :class="[currentIndex == 0 ? 'activeleft' : 'activeright']">
            <van-tabs v-model="currentIndex" @click="resetSearch">
                <van-tab v-for="(item, index) in list" :key="index" :title="item.name">
                </van-tab>
            </van-tabs>
          </div>
    </div> -->
    <div class="bind-content" id="bind">
      <van-form>
        <van-cell-group>
          <van-field
            v-if="currentIndex !== 2"
            :placeholder="'请输入' + list[currentIndex].name"
            type="number"
            v-model="searchVal"
            @blur="onBlur"
            @focus="onFocus"
          />
          <van-field
            v-if="currentIndex == 2"
            :placeholder="'请输入' + list[currentIndex].name"
            maxlength="18"
            v-model="searchVal"
          />
          <van-field
            v-model="phoneNum"
            label="手机号"
            placeholder="手机号"
            :disabled="true"
            :class="showPhoneError ? 'error-input' : ''"
            :rules="[{ validator: validatorPhone, message: '' }]"
          />
          <span class="error-notify" v-if="showPhoneError"
            >未查询到用户绑定的手机号,请到线下营业厅办理</span
          >
          <!-- <van-field
            v-model="showIdNumber"
            label="身份证号"
            placeholder="身份证号"
            :disabled="true"
            :rules="[{ validator: validatorPhone, message: '' }]"
          /> -->
          <van-field
            label="验证码"
            placeholder="请输入图形验证码"
            center
            maxlength="6"
            v-model="validateCode"
          >
            <template #button>
              <img
                :src="codeUrl"
                @click="getImageCode"
                alt="图形验证码"
                class="codeImage"
              />
              <br/>
              <span class="toggle-code" @click="getImageCode">点击切换验证码</span>
            </template>
          </van-field>
          <van-field
            label="验证码"
            placeholder="请输入手机验证码"
            center
            maxlength="6"
            v-model="verificationCode"
          >
            <template #button>
              <van-button
                size="mini"
                type="default"
                class="sms-button"
                @click="getCode"
                :disabled="!phoneNum || !validateCode || isDisabled || showPhoneError"
              >
                {{ buttonContent }}
              </van-button>
            </template>
          </van-field>
        </van-cell-group>
        <div class="submit-button">
          <van-button
            block
            type="info"
            @click="onSubmit"
            :disabled="!searchVal || !validateCode || showPhoneError"
          >
            绑定查询
          </van-button>
          <!-- <p>最多可绑定<em>5个</em>用水账户</p> -->
        </div>
      </van-form>
      <div class="pay-others">
        <!-- 跳转用户缴费 -->
        <wx-open-launch-weapp
          :id="'launch-btn' + new Date().valueOf()"
          username="gh_aceb9bd462ab"
          :path="
            'main/pages/nativeindex/nativeindex.html?fr=p&pg=charge&ct=150500&sv=1&ch=JF-EPAY2024082712301&bk=' + searchVal
          "
          style="width:200px;height:34px"
        >
          <script type="text/wxtag-template">
            <style>.test-btn-charge {width: 200px;height: 34px;background: rgba(0,0,0,0);color: #1d6fe9;font-family: PingFangSC-Medium;font-size: 18px;border: none;line-height: 44px;z-index: 3;outline: none;border-radius:8px;padding:1px 6px}</style>
            <button class="test-btn-charge">不绑定，为他人缴费</button>
          </script>
        </wx-open-launch-weapp>
      </div>
    </div>
  </div>
</template>

<script>
import scan from "../../assets/icon/scan@2x.png";
import invertedTriangle from "../../assets/icon/invertedTriangle@2x.png";
import pic_userNoExample from "../../assets/background/pic_userNoExample.png";
import { isMobile, identityId, checkName } from "@/utils/validator";
import {
  bindClient,
  selectWaterUserDetails,
  selectWaterUserParams,
  getImageCode,
  getPhoneCode,
  checkedCode,
} from "../../api/user";
import store from "@/store";
import axios from "axios";
import { Toast } from "vant";

export default {
  name: "Bind",
  data() {
    return {
      scan,
      invertedTriangle,
      pic_userNoExample,
      show: false,
      dataInfo: {
        paymentUnit: "",
        paymentUnitName: "",
        readNum: "",
        billMonth: "",
        month: "",
        signName: "",
        mobile: "",
        userNo: "",
      },
      heightFlag: true,
      submitDisabled: true,
      radio: "1",
      isDisabledSubmit: true, // 立即绑定按钮---是否禁用
      userNoExampleShow: false,
      list: [
        {
          name: "户号",
        },
        {
          name: "手机号",
        },
        {
          name: "身份证",
        },
      ],
      currentIndex: 0,
      searchVal: this.$route.query.clientCode || "",
      isDisabled: false, // 验证码按钮
      buttonContent: "获取验证码",
      wait: 60,
      phoneNum: "",
      actPhone: "",
      verificationCode: "",
      codeUrl: "",
      validateCodeKey: "",
      validateCode: "",
      searchClientInfo: {},
      showPhoneError: false,
      clientIdNumber: "",
      showIdNumber: "",
      cto: undefined
    };
  },
  mounted() {
    this.searchClientInfo = {};
    this.getImageCode();
    if(this.searchVal) {
      this.onBlur();
    }
  },
  methods: {
    toSearchNO() {
      this.$router.push({ path: '/Bind/searchClientNo' });
    },
    validatorPhone(val) {
      return isMobile(val);
    },
    resetSearch() {
      this.searchVal = "";
      if (this.currentIndex === 1) {
        this.searchVal = store.state.user.mobile;
      }
    },
    onFocus() {
      this.showPhoneError = false;
      this.actPhone = "";
      this.phoneNum = "";
      this.showIdNumber = "";
      this.clientIdNumber = "";
      this.searchClientInfo = {};
      this.validateCode = "";
      this.validateCodeKey = "";
      this.code = "";
      this.getImageCode();
    },
    async onBlur() {
      this.showPhoneError = false;
      this.actPhone = "";
      this.phoneNum = "";
      this.showIdNumber = "";
      this.clientIdNumber = "";
      this.searchClientInfo = {};
      if (this.currentIndex === 0 && this.searchVal) {
        const {
          status,
          resultData,
          errorMessage,
        } = await selectWaterUserDetails(this.searchVal);
        console.log(resultData);
        if (resultData || resultData.length > 0) {
          this.searchClientInfo = resultData[0];
          this.actPhone = resultData[0].clientPhone || '';
          this.clientIdNumber = resultData[0].clientIdNumber || '';
          if(!resultData[0].clientPhone) {
            this.showPhoneError = true;
            // this.phoneNum = '手机号不存在,请到线下营业厅办理';
          } else {
            this.phoneNum = this.actPhone.replace(
              /(\d{3})\d*(\d{4})/,
              "$1****$2"
            );
          }
          if(resultData[0].clientPhone) {
            this.showIdNumber = resultData[0].clientIdNumber.replace(
              /(\d{4})\d*(\d{4})/,
              "$1****$2"
            );
          }
        } else {
          this.showPhoneError = true;
        }
      }
    },
    async getImageCode() {
      if (!store.getters.userInfo.userId) return;
      let data = await getImageCode(store.getters.userInfo.userId);
      const { key, code } = data.resultData;
      this.codeUrl = "data:image/gif;base64," + code;
      this.validateCodeKey = key;
    },
    // 获取验证码
    async getCode() {
      let phone = this.actPhone || this.phoneNum;
      if (this.validatorPhone(phone)) {
        this.getSendMessage();
        let arg = {
          phone: phone,
          accountId: store.getters.userInfo.userId,
          validateCodeKey: this.validateCodeKey,
          validateCode: this.validateCode,
          accountType: "wx",
        };
        const { status, resultData, errorMessage } = await getPhoneCode(arg);
        if (status === "complete") {
          Toast({ icon: "passed", message: "发送成功！" });
        } else {
          clearInterval(this.cto);//清除定时器
          this.isDisabled = false;
          this.buttonContent = "获取验证码";
          Toast({ icon: "close", message: errorMessage || "发送失败！" });
        }
      } else {
        Toast("请请输入正确的手机号");
      }
    },
    // 验证码倒计时
    getSendMessage() {
      if (this.wait === 0) {
        this.isDisabled = false;
        this.buttonContent = "重新获取验证码";
        this.wait = 60;
      } else {
        this.isDisabled = true;
        this.buttonContent = this.wait + "s后重新获取";
        this.wait--;
        this.cto = setTimeout(() => {
          this.getSendMessage();
        }, 1000);
      }
    },
    // 通过身份证/手机号绑定页面
    goToUserInfoBind() {
      this.$router.push({
        path: "/Bind/householderInfo",
      });
    },
    changeVal(e) {
      if (this.currentIndex === 1) {
        let reg = /^(((\d{3,4}-)?[0-9]{7,8})|(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8})$/;
        if (!reg.test(e)) {
          return Toast.fail("手机号不存在，请重新输入手机号");
        }
      }
      if (this.currentIndex === 2) {
        let reg = /^[0-9Xx]*$/;
        if (!reg.test(e)) {
          return Toast.fail("身份证号不存在，请重新输入身份证号");
        }
      }
    },
    // 提交
    async onSubmit() {
      let phone = this.actPhone || this.phoneNum;
      let reg = /^(((\d{3,4}-)?[0-9]{7,8})|(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8})$/;
      if (!reg.test(phone)) {
        return Toast.fail("手机号不存在，请重新输入手机号");
      }
      if (!this.verificationCode) {
        Toast.fail("验证码不能为空");
        return;
      }
      let check = {
        phone: this.actPhone || this.phoneNum,
        accountId: store.getters.userInfo.userId,
        validateCodeKey: this.validateCodeKey,
        validateCode: this.validateCode,
        accountType: "wx",
        code: this.verificationCode,
      };
      let data = await checkedCode(check);
      if (data.status === "complete") {
        this.$router.push({
          path: "/Bind/selectBindAccount",
          name: "SelectBindAccount",
          query: {
            clientCode: this.searchClientInfo.clientCode,
            phone: this.searchClientInfo.clientPhone,
            clientIdNumber: '',
          },
        });
      } else {
        let message = data.errorMessage || "验证码错误，请重新验证！";
        Toast.fail(message);
        return;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bind-page {
  overflow-x: hidden;
  background-color: #ffffff;
  .bind-header {
    display: flex;
    margin-top: 33px;
    padding-left: 16px;
    text-align: left;
    height: 80px;
    p {
      font-family: PingFangSC-Medium;
      font-size: 24px;
      color: #1c2734;
      line-height: 26px;
      margin: 0px;
    }
    span {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      line-height: 26px;
      margin-bottom: 36px;
      padding-top: 2px;
      margin-right: 20px;
      flex: 1;
      text-align: end;
    }
  }
  .bind-content {
    display: inline-block;
    width: 90%;
    margin: 10px 20px 15px 20px;
    /deep/.van-cell__title {
      span {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #333333;
      }
    }
    /deep/.van-field__control {
      display: inline-block;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #000;
      font-weight: 800;
      height: 44px;
      background-color: #eee;
      padding-left: 12px;
      border-radius: 10px;
    }
    .error-input {
      /deep/.van-field__control {
        color: red;
      }
    }
    /deep/.van-field__right-icon {
      font-size: 16px;
    }
    /deep/.title_quester::after {
      display: inline-block;
      width: 18px;
      height: 18px;
      content: "";
      vertical-align: middle;
      background: url("../../assets/icon/question@2x.png") no-repeat 3px -1px;
      background-size: cover;
    }
    /deep/.van-field__label {
      margin-right: 0px;
      display: none;
    }
    .bind-userinfo {
      text-align: left;
      margin: 0px;
      padding-left: 16px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #4466ad;
      padding-top: 20px;
      padding-bottom: 10px;
      display: inline-block;
    }
    ::-webkit-input-placeholder {
      /* WebKit, Blink, Edge */
      color: #cccccc;
      font-size: 16px;
    }
    .submit-button {
      border-radius: 10px;
      margin: 56px 1px 0px;
      margin-bottom: 60px;
      p {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #999999;
        text-align: center;
        line-height: 17px;
        margin-top: 12px;
        em {
          font-style: normal;
        }
      }
      .van-button__text {
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #ffffff;
        text-align: center;
      }
      .van-button {
        border-radius: 10px;
      }
    }
    .sms-button {
      border-radius: 4px;
      width: 140px;
      background: #1989fa;
      color: #fff;
      height: 44px;
      font-size: 16px;
    }
  }
  .title {
    border-bottom: 1px solid #eeeeee;
    padding-top: 12px;
    padding-bottom: 12px;
    p {
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #333333;
      text-align: center;
      line-height: 26px;
      margin: 0px;
    }
    span {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #999999;
      text-align: center;
      line-height: 26px;
      display: block;
    }
  }
  .editLabel {
    .title {
      border-bottom: 1px solid #eeeeee;
      padding-top: 12px;
      padding-bottom: 12px;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #333333;
      text-align: center;
      line-height: 22px;
    }
    .inputLabel {
      width: 90%;
      margin: 12px;
      border: 1px solid red;
      background: #f9f8f8;
      border-radius: 4px;
      margin-left: 20px;
    }
    .button {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #0a79ec;
      text-align: center;
    }
  }
  /deep/.van-cell {
    margin-top: 20px;
    padding: 0;
  }
}

.business {
  padding: 0;
  box-shadow: 0 6px 6px 0 #3333330d;
  background: #f5f7f9;
  overflow: hidden;
  border-radius: 10px;
  width: 90%;
  margin: 0 auto;

  .title-item {
    color: #fff;
  }

  .business-header {
    padding: 12px 12px 6px 12px;
    height: 160px;
    box-sizing: border-box;
    // display: flex;
    // flex-direction: column;
    font-weight: 500;
    font-size: 26px;
    color: #fff;
    background-image: linear-gradient(243deg, #48a2ff 0%, #6a99f8 100%);
    overflow: visible;

    &-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fff;

      img {
        width: 148px;
        height: 118px;
      }

      li:first-child {
        padding-left: 24px;
      }
    }

    &-tab {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 15px;
      color: #ffffff;

      li:not(:first-child) {
        margin-left: 24px;
      }

      li {
        width: 25%;
      }
    }

    .active-tab {
      position: relative;

      &-img {
        position: absolute;
        top: -2px;
        left: -19px;
        width: 104px;
        height: 33px;
      }
    }
  }

  .business-content {
    height: calc(100vh - 235px);
    overflow: auto;
    padding: 15px;
    box-sizing: border-box;
    text-align: center;

    .warp {
      position: relative;
      top: 8px;
    }

    ul {
      margin-top: 20px;

      li:first-child {
        display: flex;
        align-items: center;
        padding: 10px 0;
        box-sizing: border-box;
        font-size: 16px;
        font-weight: 500;

        .content-tag {
          margin-left: 12px;
          padding: 3px;
          font-size: 12px;
          color: #fff;
          background-color: #ee0a24;
          border-radius: 50%;
        }

        /deep/ .van-badge {
          margin-left: 12px;
        }
      }

      .van-grid {
        padding-left: 0 !important;

        .van-grid-item__content {
          box-shadow: 2px 2px 4px 0 rgba(213, 218, 225, 0.3);
          border-radius: 8px;
        }
      }

      &:first-child {
        margin-top: 0;
      }
    }

    &-title {
      margin-top: 12px;
      font-size: 14px;
      color: #666666;
    }
  }

  &-item {
    color: #666;
    font-size: 14px;
    line-height: 20px;

    &:nth-child(-n + 3) {
      margin-bottom: 20px;
    }

    img {
      width: 25px;
      height: 25px;
      margin-bottom: 12px;
    }

    .water {
      width: 21px;
      height: 26px;
    }
  }

  /deep/ .van-grid-item__content {
    padding: 0;
    margin-bottom: 12px;
  }
}

.van-tabs {
  .van-tabs__wrap {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
}

.title-wrap {
  height: 36px;
  font-size: 14px;
  color: #4285f4;
  line-height: 36px;
  padding: 8px;

  .active-tab-title {
    font-size: 16px;
    font-weight: bolder;
  }
}

.company-title {
  text-align: center;
  font-size: 18px;
  color: #fff;
  margin: 12px 0;
}

.swiper-box {
  display: flex;
  flex-wrap: wrap;

  .swiper-items {
    box-sizing: border-box;
    width: 25%;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    height: 80px;
    padding-top: 8px;
    cursor: pointer;

    > p {
      width: 100%;
      height: 32px;
      line-height: 16px;
      text-align: center;
      color: #666;
      margin: 0;
    }
  }
}

.tansnTip {
  position: absolute;
  z-index: 10;
  width: 0;
  height: 0;
  top: 94px;
  transition: 0.2s;
  border-bottom: 10px solid #fff;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 10px solid transparent;
}

.show-operate {
  margin: 8px 0 8px 12px;
  font-size: 14px;
  color: #666;
}

.my-swipe {
  height: max-content;

  .van-swipe-item {
    box-shadow: 2px 2px 4px 0 rgba(213, 218, 225, 0.3);
    z-index: 9999;
  }
}

.van-swipe__indicators {
  .van-swipe__indicator {
    background-color: #7a7e85;
  }

  .van-swipe__indicator--active {
    background-color: #1989fa;
  }
}

/deep/.van-tabs__nav {
  background-color: transparent;

  .van-tab {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
  }

  .van-tab--active {
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #fff;
    text-align: center;
    background: #1989fa;
    border-radius: 10px;
  }
}

/deep/.van-tabs__line {
  background-color: transparent;
}

.pay-others {
  text-align: center;
  margin-bottom: 40px;
}

.pay-link {
  color: #0100f9;
  font-size: 16px;
  font-weight: 600;
  font-family: PingFangSC-Regular;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0px;
}
/deep/.van-cell::after {
  border-width: 0px;
}
.error-notify {
  color: red;
  font-family: PingFangSC-Regular;
  margin-left: 10px;
}
.codeImage {
  position: relative;
  top: 4px;
  height: 60px;
}
.toggle-code {
  color:#0a79ec;
}
</style>
